export default __webpack_public_path__ + "static/media/esquema-landing.740dbf35.svg";